import clg from "./log"

const modifyState = ( state, setter, modify ) => {

    let modified = {};

    Object.keys(modify).forEach((key, index) => {
        modified[key] = modify[key];
    });

    setter({
        ...state,
        ...modified,
    })
}

export default modifyState;